import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Img from 'gatsby-image'

const Container = styled.div`
  border-radius: 8px;
  overflow: hidden;
  max-width: 200px;

  ${breakpoint('tablet')`
    max-width: none;
  `}

  .gatsby-image-wrapper {
    transition: all 0.5s ease;
    border-radius: 8px;
    overflow: hidden;

    &:hover:after {
      content: 'Más información >>';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 5px;
      text-align: center;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }
  }
`

export default ({ link, imagen, alt }) => {
  return (
    <Container>
      <a href={link}>
        <Img fluid={imagen} alt={alt} />
      </a>
    </Container>
  )
}
